<template lang="pug">
  .default-pdp-hero.xs-12.xs-pt-100m.md-pl-30pct.md-pr-30pct
    .product-imagery.xs-12.md-7.md-pr-100m
      PdpCarousel(:key="this.product.code"  :images="pdpCarouselImages"  :bottom-nav="true")
        template(v-slot:first-image="")
          PdpCarouselRibbon(:product="product")

    .product-info-and-cta.xs-12.md-5
      PdpProductInfo
      PdpPriceModule.xs-mb-50m(v-if="showPriceModule")
      PdpSwatchSelector
      p.short-desc.xs-f-small.md-f-medium.max-at-tweak(itemprop="description") {{ shortDescription }}
      ColorSolveSelector
      PdpBestMatch.xs-mb-150m(v-if="showBestMatch"  :product-type="product.product_type")
      PdpGoesWithColor.xs-mb-150m
      PdpMissingAdvisor.xs-mb-150m
      slot(name="middle")
      PdpTransactionalInfo.info-section.t-line.xs-pt-100m.xs-pb-100m.xs-pl-30pct.xs-pr-30pct.sm-pl-0pct.sm-pr-0pct
      PdpCTAs.info-section.t-line.xs-pt-100m.xs-pl-30pct.xs-pr-30pct.md-pl-0pct.md-pr-0pct(:cta-source="ctaSource")
      .xs-12
        DeliveryOptions

</template>

<script>
  import { mapState } from 'vuex';
  import PdpCarousel from '../../PdpCarousel';
  import PdpProductInfo from '../../PdpProductInfo';
  import PdpGoesWithColor from '../../PdpGoesWithColor';
  import PdpSwatchSelector from '../../PdpSwatchSelector';
  import PdpMissingAdvisor from '../../PdpMissingAdvisor';
  import PdpTransactionalInfo from '../../PdpTransactionalInfo';
  import PdpCTAs from '../../PdpCTAs';
  import PdpCarouselImageMixin from '../../PdpCarouselImageMixin';
  import PdpCarouselRibbon from '../../PdpCarouselRibbon';
  import PdpBestMatch from '../../PdpBestMatch';
  import DeliveryOptions from '@components/PDP/DeliveryOptions';
  import ColorSolveSelector from '@components/PDP/ColorSolveSelector';
  import PdpPriceModule from "@components/PDP/PdpPriceModule/PdpPriceModule";

  export default {
    name: 'DefaultPdpHero',

    components: {
      PdpPriceModule,
      PdpCarousel,
      PdpCarouselRibbon,
      PdpProductInfo,
      PdpGoesWithColor,
      PdpSwatchSelector,
      PdpMissingAdvisor,
      PdpTransactionalInfo,
      PdpCTAs,
      PdpBestMatch,
      DeliveryOptions,
      ColorSolveSelector
    },

    mixins: [PdpCarouselImageMixin],

    inject: ['getObjProperty'],

    computed: {
      ...mapState('pdp', [
        'product',
        'showPriceModule'
      ]),

      shortDescription() {
        return this.getObjProperty(this.product, 'desc.short');
      },

      ctaSource() {
        return this.getObjProperty(this.product, 'product_type_name');
      },

      pdpCarouselImages() {
        return this.mix_pdpCarouselImages;
      },

      showBestMatch() {
        return Boolean(this.getObjProperty(this.product, 'product_type') == 'root_reboot');
      },
    }
  };
</script>

<style scoped lang="stylus">
  .default-pdp-hero
    .product-info-and-cta
      .info-section
        position relative

        &.t-line
          &:before
            content ''
            position absolute
            top 0
            left 0
            right 0
            border-top 1px solid ui-color-5

    .short-desc
      padding-bottom 1em

    @media mq-tablet-less
      .short-desc
        padding 0 10%
        padding-bottom 0.5em
</style>
